import { render, staticRenderFns } from "./ImportLayoutGrid.vue?vue&type=template&id=72872955"
import script from "./ImportLayoutGrid.vue?vue&type=script&lang=js"
export * from "./ImportLayoutGrid.vue?vue&type=script&lang=js"
import style0 from "./ImportLayoutGrid.vue?vue&type=style&index=0&id=72872955&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports